var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { singleton } from '../../decorators';
let OrganizationDepartmentService = class OrganizationDepartmentService {
    api;
    getAuthHeader;
    constructor(api, getAuthHeader) {
        this.api = api;
        this.getAuthHeader = getAuthHeader;
    }
    async getOrganizationDepartments() {
        const res = await fetch(this.api + '/organization-departments', {
            method: 'GET',
            headers: {
                ...(await this.getAuthHeader()),
                'Content-Type': 'application/json',
            },
        });
        const data = await res.json();
        return data;
    }
    async getOrganizationDepartment(id) {
        const res = await fetch(`${this.api}/organization-departments/${id}`, {
            mode: 'cors',
            method: 'GET',
            headers: {
                ...(await this.getAuthHeader()),
                'Content-Type': 'application/json',
            },
        });
        const data = await res.json();
        return data;
    }
    async createOrganizationDepartment(entry) {
        const res = await fetch(this.api + '/organization-departments', {
            mode: 'cors',
            method: 'POST',
            headers: {
                ...(await this.getAuthHeader()),
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(entry),
        });
        const data = await res.json();
        return data;
    }
    async updateOrganizationDepartment(id, entry) {
        const res = await fetch(`${this.api}/organization-departments/${id}`, {
            mode: 'cors',
            method: 'PUT',
            headers: {
                ...(await this.getAuthHeader()),
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(entry),
        });
        const data = await res.json();
        return data;
    }
    async shareOrganizationDepartment(id, sharedWith) {
        const res = await fetch(`${this.api}/organization-departments/${id}/share`, {
            mode: 'cors',
            method: 'POST',
            headers: {
                ...(await this.getAuthHeader()),
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ sharedWith }),
        });
        if (!res.ok) {
            throw new Error('Failed to share organization department');
        }
        const data = await res.json();
        return data;
    }
    async deleteOrganizationDepartment(id) {
        const res = await fetch(`${this.api}/organization-departments/${id}`, {
            mode: 'cors',
            method: 'DELETE',
            headers: {
                ...(await this.getAuthHeader()),
            },
        });
        if (!res.ok) {
            throw new Error('Failed to delete organization department');
        }
        const data = await res.json();
        return data;
    }
};
OrganizationDepartmentService = __decorate([
    singleton,
    __metadata("design:paramtypes", [String, Function])
], OrganizationDepartmentService);
export { OrganizationDepartmentService };
//# sourceMappingURL=data:application/json;base64,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